import React from "react";
import styled from "styled-components";
import { colors } from "../resources/ThemeColors";
import { breakpoints } from "../Media";

const MainDiv = styled.div`
  bottom: 0;
  background-color: ${colors.light};
  color: ${colors.main};
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
`;

const ContentDiv = styled.div`
  width: 90vw;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 2em;
  @media (max-width: ${breakpoints.mobileMax}) {
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
  }
`;

const AppDownloadButtonDiv = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  margin-top: 2em;
  @media (max-width: ${breakpoints.mobileMin}) {
    flex-flow: column nowrap;
  }
`;

const FooterDetailsDiv = styled.div`
  display: flex;
  width: 40vw;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${breakpoints.mobileMin}) {
    flex-flow: column nowrap;
    justify-content: center;
    width: unset;
  }
`;

const Item = styled.a`
  font-size: 0.9em;
  font-weight: 500;
  text-decoration: none;
  margin-top: 1em;
  cursor: pointer;
`;

const CopyRightDiv = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  background-color: ${colors.main};
  margin-top: 1.5em;
  @media (max-width: ${breakpoints.mobileMax}) {
    align-items: center;
    justify-content: center;
  }
`;

const CopyRight = styled.p`
  font-size: 0.8em;
  font-weight: 700;
  padding-top: 0.1em;
  padding-bottom: 0.1em;
  color: white;
  margin-right: 1.5em;
`;

function Footer() {
  return (
    <MainDiv>
      <ContentDiv>
        <AppDownloadButtonDiv id="bottom">
          <p>Coming Soon</p>
          <a href="/">
            <img
              alt="Coming Soon"
              style={{ width: "10em" }}
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
            />
          </a>
          <a href="/">
            <img
              alt={"Get it on App Store"}
              style={{ width: "8em" }}
              src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg"
            />
          </a>
        </AppDownloadButtonDiv>
        <FooterDetailsDiv>
          <Item>About Us</Item>
          <Item>Join the Q</Item>

          <Item>
            <a
              href="/hairQ/privacy-policy"
              style={{
                color: colors.main,
                textDecoration: "none",
              }}
            >
              Privacy Policy
            </a>
          </Item>

          <Item>
            <a
              href="/hairQ/cookie-policy"
              style={{
                color: colors.main,
                textDecoration: "none",
              }}
            >
              Cookie Policy{" "}
            </a>
          </Item>
        </FooterDetailsDiv>
      </ContentDiv>
      <CopyRightDiv>
        <CopyRight>&copy; HairQ {new Date().getFullYear()}</CopyRight>
      </CopyRightDiv>
    </MainDiv>
  );
}

export default Footer;
